import { components } from "react-select";

export const requestTypeOptions = [
  { label: "Classification", value: "Classification" },
  // { label: "Controls", value: "Controls" },
  // { label: "Documents", value: "Documents" },
];

export const SelectCustomStyles = {
  control: (base, state) => ({
    ...base,
    "&:hover": {
      border: "solid 1px #d0d5dd",
      boxShadow: "0 0 0 2px #f1ecfe",
      borderRadius: "4px",
    },
    "&:active": {
      border: "solid 1px #7143f1",
      boxShadow: "0 0 0 2px #f1ecfe",
      borderRadius: "4px",
      backgroundColor: "#f9f9f9",
    },
    "&:focus": {
      border: "solid 1px #7143f1",
      boxShadow: "0 0 0 2px #f1ecfe",
      borderRadius: "4px",
      backgroundColor: "#fff",
    },
    "&:disabled": {
      backgroundColor: "#e9ecef",
    },
    maxHeight: "32px !important",
    minHeight: "32px !important",
    height: "32px !important",
    backgroundColor: "#fff",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "normal",
    color: "#667085",
    border: state.isFocused ? "1px solid #7143f1" : "1px solid #d0d5dd",
    boxShadow: state.isFocused ? "0 0 0 2px #f1ecfe" : "none",
    cursor: state.isDisabled ? "not-allowed !important" : "pointer !important",
    pointerEvents: "auto !important",
    width: "100%",
    minWidth: "150px",
    maxWidth: "300px",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "32px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
  }),
  input: (base) => ({
    ...base,
    padding: "0",
    margin: "0",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "32px",
    display: "flex",
    alignItems: "center",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "6px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: "normal",
    padding: "4px",
    color: "#667085",
    border: "solid 1px #7143f1",
    boxShadow: "0 0 0 2px #f1ecfe",
    borderRadius: "4px",
    backgroundColor: "#fff",
    zIndex: 9999,
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    marginBottom: "4px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  placeholder: (base) => ({
    ...base,
    color: "#667085",
    fontSize: "14px",
    fontWeight: "normal",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#667085",
    fontSize: "14px",
    fontWeight: "normal",
  }),
};

export const customSelectStyle2 = {
  control: (base, state) => ({
    ...base,
    height: "44px",
    opacity: 1,
    borderRadius: "8px",
    fontSize: "14px",
    width: "100%",
    color: "#212529",
    border: state.isFocused ? "solid 1px #7143f1" : "solid 1px #d0d5dd",
    boxShadow: state.isFocused ? "0 0 0 2px rgb(108 56 255 / 20%)" : "none",
    "&:hover": {
      boxShadow: "0 0 0 2px rgb(108 56 255 / 20%)",
      border: "solid 1px #7143f1",
    },

    backgroundColor: state.isDisabled ? "#F2F4F7" : "#fcfcfd",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    color: "#212529",
    padding: "8px",
    width: "100%",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "rgba(111, 8, 241, 0.1)" : null,
    color: isDisabled ? null : isSelected ? "#212529" : isFocused ? "#212529" : null,
    cursor: "pointer !important",
    marginBottom: "8px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#212529 !important",
    fontWeight: "500",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

export const priorityOptions = [
  { label: "High", value: "high" },
  { label: "Medium", value: "medium" },
  { label: "Low", value: "low" },
];

export const classificationOptionsEnums = {
  import: "Import HS",
  export: "Export HS",
};

export const classificationOptions = [
  { label: "Import HS", value: "import" },
  { label: "Export HS", value: "export" },
  // { label: "ECCN", value: "eccn" },
];

export const CheckboxOption = (props) => {
  return (
    <components.Option {...props} className="d-flex align-items-center label-md-regular tw-gap-3">
      <input type="checkbox" checked={props.isSelected} onChange={() => null} className="tw-accent-primary-purple-500" />
      {props.label}
    </components.Option>
  );
};

export const MultiValueContainer = ({ index, getValue }) => {
  const maxToShow = 1;
  const length = getValue().length;
  const displayChips = getValue().slice(0, maxToShow);
  const shouldBadgeShow = length > maxToShow;
  const displayLength = length - maxToShow;
  const allPresent = getValue().some((option) => option.value === "ALL");

  return (
    !index && (
      <div className="tw-flex tw-gap-1 tw-items-center tw-max-w-full">
        {!allPresent &&
          displayChips.map((item, idx) => (
            <span key={idx} className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-max-w-[250px] tw-inline-block">
              {item.label}
            </span>
          ))}
        {shouldBadgeShow && !allPresent ? <span className="tw-flex-shrink-0 tw-font-bold">+{displayLength}</span> : null}
        {allPresent ? <div className="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-max-w-[250px]">{getValue()[0].label}</div> : null}
      </div>
    )
  );
};

export const filterLabel = {
  priority: "Priority",
  assignedTo: "Assigned To",
  status: "Status",
  createdBy: "Created By",
  classificationType: "Request Type",
};

export const classificationTabEnum = [
  { label: "Import HS Classification", value: "Imports" },
  { label: "Export HS Classification", value: "Exports" },
  { label: "ECCN Classification", value: "Eccn" },
  // { label: "Import Controls", value: "import_controls" },
  // { label: "Export Controls", value: "export_controls" },
];

export const sixDigitsHscodes = [
  { hscode: "HS 600123", desc: "HS Code Description will come here" },
  { hscode: "HS 600124", desc: "HS Code Description will come here" },
  { hscode: "HS 600125", desc: "HS Code Description will come here" },
  { hscode: "HS 600126", desc: "HS Code Description will come here" },
];

export const tenDigitsHscodes = [
  {
    hscode: "HS 6001234567",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis",
  },
  { hscode: "HS 6001244567", desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
  { hscode: "HS 6001254567", desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
  { hscode: "HS 6001254567", desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
  { hscode: "HS 6001254567", desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
];

export const getInitials = (string = "") => {
  if (!string || !string?.trim()) return;
  const nameString = string.trim();
  const names = nameString.split(" ");
  const initials = names[0]?.[0]?.toUpperCase() || "";

  if (names.length > 1) {
    return initials + names[names.length - 1][0].toUpperCase();
  }
  return initials;
};

export const generateColor = (name, isDark = false) => {
  const safeName = name || "";
  const hash = safeName.split("").reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  if (isDark) {
    const h = hash % 360;
    return `hsl(${h}, 70%, 35%)`;
  } else {
    const h = hash % 360;
    return `hsl(${h}, 70%, 85%)`;
  }
};
